import type { Notification } from '@/features/notifications/types/Notifications.types';

/**
 * Mocked notification data for development and testing
 * Contains a mix of read and unread notifications with various timestamps
 */
export const mockNotifications: Notification[] = [
  {
    id: '1',
    title: 'New voyage assigned',
    description: 'You have been assigned to manage voyage VY-2024-001',
    timestamp: new Date(Date.now() - 5 * 60 * 1000), // 5 minutes ago
    isRead: false,
    actionLink: '/voyage/VY-2024-001'
  },
  {
    id: '2',
    title: 'Inspection report ready',
    description: 'The inspection report for MV Ocean Star is now available',
    timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000), // 2 hours ago
    isRead: false,
    actionLink: '/inspections/reports/12345'
  },
  {
    id: '3',
    title: 'Document approval needed',
    description: 'Please review and approve the cargo manifest for voyage VY-2024-002',
    timestamp: new Date(Date.now() - 4 * 60 * 60 * 1000), // 4 hours ago
    isRead: true,
    actionLink: '/documents/pending/67890'
  },
  {
    id: '4',
    title: 'Form submission received',
    description: 'Your safety drill form has been successfully submitted',
    timestamp: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000), // 1 day ago
    isRead: true,
    actionLink: '/forms/submissions/45678'
  },
  {
    id: '5',
    title: 'System maintenance scheduled',
    description: 'Planned system maintenance on Saturday 2:00 AM - 4:00 AM UTC',
    timestamp: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000), // 2 days ago
    isRead: false,
    actionLink: '/system/maintenance'
  }
];
